module.exports = __webpack_public_path__ + "static/img/5228_phase_function_Paper_PointsHejduk_Prediction.6a5617d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5228_phase_function_Paper_PointsHejduk_Prediction.png
// module id = SfkS
// module chunks = 0